var brandColors = {
  primary: "#f1592a",
  secondary: "#293F4D"
};

export { brandColors };
